exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LinkButtons2 .link-buttons{border-width:1px;border-style:none solid solid none}.LinkButtons2 .link-button{border-width:1px;border-style:solid none none solid}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/LinkButtons2/LinkButtons2.scss
// module id = 1023
// module chunks = 34